import { render, staticRenderFns } from "./DinamikFilter.vue?vue&type=template&id=5abfa44c&scoped=true"
import script from "./DinamikFilter.vue?vue&type=script&lang=js"
export * from "./DinamikFilter.vue?vue&type=script&lang=js"
import style0 from "./DinamikFilter.vue?vue&type=style&index=0&id=5abfa44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abfa44c",
  null
  
)

export default component.exports